<div class="im dash">

  <app-sm>
    <app-sm-icon [soType]="'assets'" [ttText]="'select your assets'">
      <mat-icon>settings_input_component</mat-icon>
    </app-sm-icon>
    <app-sm-icon *ngIf="curDate" [soType]="'date'" [ttText]="'select a date'">
      <div class="date-icon">
        <div>{{moment(curDate).format('DD')}}</div>
        <div>{{moment(curDate).format('MM')}}</div>
      </div>
    </app-sm-icon>
    <app-sm-icon *ngIf="curDate && assets?.length"
                 [ttText]="'download all data'"
                 [withTopMargin]="true">
      <mat-icon (click)="onDownload('', 'all')" color="accent">download_for_offline</mat-icon>
    </app-sm-icon>

    <app-sm-icon [ttText]="'user manual'"
                 class="user-manual-icon">
      <a href="./assets/WARP User Manual (SPaaS, Engie).pdf"
         target="_blank"
         rel="noopener"
         aria-label="link to user manual">
        <mat-icon color="primary">help</mat-icon>
      </a>
    </app-sm-icon>
  </app-sm>

  <!-- TOP ROW WITH PAGINATOR -->
  <div class="flex-it">
    <div class="im__paginator">
      <div *ngIf="assets?.length; else NoAssets"
           class="im__paginator__row">
        <div (click)="goToCountrySlide(countryIdx)"
             *ngFor="let country of assets; let countryIdx = index"
             [class.active]="countrySwiperIdx === countryIdx">
          {{country.label}}
        </div>
      </div>
      <ng-template #NoAssets>
        <div *ngIf="!isAssetSoActive && !isLoading" class="no-assets">
          <h3>please select some assets</h3>
          <svg viewBox="0 0 184 184">
            <use [attr.xlink:href]="'assets/images/assets-arrow.svg#svg1'"></use>
          </svg>
        </div>
      </ng-template>
    </div>
    <h1>STO Intramonth Plan</h1>
  </div>

  <!-- BOTTOM ROW WITH SWIPER -->
  <div class="im__swiper">

    <div [index]="countrySwiperIdx" [swiper]="countrySwiperConfig" class="swiper-container">

      <div class="swiper-wrapper">

        <!-- SLIDE PER COUNTRY -->
        <ng-container *ngFor="let country of assets; let countryIndex = index;">

          <div class="swiper-slide slide-noswiping">

            <!-- MARKET FUNDAMENTALS CHART -->
            <div class="im__swiper__title">
              market fundamentals
              <div class="im__swiper__title__icons">
                <mat-icon (click)="onDownload(country.label, 'mf')"
                          class="accent"
                          matTooltip="download"
                          matTooltipClass="bg-accent">
                  download_for_offline
                </mat-icon>
              </div>
            </div>
            <div class="im__swiper__charts">
              <div class="with-box-shadow">
                <app-market-chart [country]="country"></app-market-chart>
              </div>
            </div>

            <ng-container *ngIf="country.assetsSelected.length; else NoAssetsSelected">

              <!-- ASSET CHARTS -->
              <div class="im__swiper__title">
                assets
                <div class="im__swiper__title__icons">
                  <mat-icon (click)="onToggleAssetSwiper()"
                            [class.primary]="withGridView"
                            [matTooltipClass]="withGridView ? 'bg-primary' : 'bg-color'"
                            matTooltip="grid view on/off">
                    grid_view
                  </mat-icon>
                  <mat-icon (click)="onDownload(country.label,'assets')"
                            class="accent"
                            matTooltip="download"
                            matTooltipClass="bg-accent">
                    download_for_offline
                  </mat-icon>
                </div>
              </div>
              <div
                [style.height.px]="withGridView ? swiperBaseHeight * ((country.assetsSelected.length + country.assetsSelected.length % 2) / 2) : swiperBaseHeight"
                class="im__swiper__charts flex-it col">

                <div [index]="assetSwiperConfigs[countryIndex].idx"
                     [swiper]="assetSwiperConfigs[countryIndex].cfg"
                     class="swiper-container">

                  <div class="swiper-wrapper">

                    <ng-container *ngFor="let cust of country.customers">

                      <ng-container *ngFor="let cat of cust.cats">

                        <ng-container *ngFor="let asset of cat.assets">

                          <div *ngIf="asset.selected" class="swiper-slide slide-noswiping">
                            <div class="with-box-shadow">
                              <app-asset-chart [asset]="asset" [cust]="cust"></app-asset-chart>
                            </div>
                          </div>

                        </ng-container>

                      </ng-container>

                    </ng-container>

                  </div>

                </div>

                <app-chart-pag (idx)="goToAssetSlide(countryIndex, $event)"
                               *ngIf="!withGridView"
                               [pages]="country.assetsSelected">
                </app-chart-pag>

              </div>

              <!-- OUTAGE COST CHART -->
              <div class="im__swiper__title">
                outage cost
                <div class="im__swiper__title__icons">
                  <mat-icon (click)="onToggleOutageTable()"
                            [class.primary]="withOutageTable"
                            [matTooltipClass]="withOutageTable ? 'bg-primary' : 'bg-color'"
                            matTooltip="table on/off">
                    view_list
                  </mat-icon>
                  <mat-icon (click)="onDownload(country.label,'oc')"
                            class="accent"
                            matTooltip="download"
                            matTooltipClass="bg-accent">
                    download_for_offline
                  </mat-icon>
                </div>
              </div>
              <div class="im__swiper__charts">
                <div class="with-box-shadow">
                  <app-outage [country]="country" [withTable]="withOutageTable"></app-outage>
                </div>
              </div>

              <!-- POSITION OVERVIEW CHART -->
<!--              <div class="im__swiper__title">-->
<!--                position overview-->
<!--                <div class="im__swiper__title__icons">-->
<!--                  <mat-icon (click)="onDownload(country.label,'pos')"-->
<!--                            class="accent"-->
<!--                            matTooltip="download"-->
<!--                            matTooltipClass="bg-accent">-->
<!--                    download_for_offline-->
<!--                  </mat-icon>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="im__swiper__charts">-->
<!--                <div class="with-box-shadow">-->
<!--                  <app-position-chart [country]="country"></app-position-chart>-->
<!--                </div>-->
<!--              </div>-->

            </ng-container>
            <ng-template #NoAssetsSelected>
              <div class="im__swiper__title">no assets selected for {{country.label}}</div>
            </ng-template>

          </div>

        </ng-container>

      </div>

    </div>

  </div>

</div>

<!-- SLIDE-OUT CHILDREN -->
<app-assets-tree></app-assets-tree>
<app-date></app-date>
